import Button from '@/components/core/Button';
import Dropdown from '@/components/core/Dropdown';

import { list } from '@/graph/physicians';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import React, { useCallback, useMemo } from 'react';
import { Calendar } from 'react-date-range';
import graphqlSelectInput from '../../../inputs/graphqlSelectInput';

export const PhysicianDropdown = graphqlSelectInput({
  entityName: 'Physician',
  placeholder: 'Physician',
  graphqlList: list,
  size: 'small',
  variant: 'outlined',
  sortOptions: true,
  getOptionValue: option => (option ? parseInt(option.value, 10) : undefined),
});

const CalendarContent = ({ date, onSelect, close }) => {
  const handleChange = useCallback(
    d => {
      close();
      onSelect(d);
    },
    [close, onSelect]
  );
  return <Calendar date={date} onChange={handleChange} />;
};

const Filters = ({ date, physician, withoutPhysician, onChange, buttonFormat }) => {
  const classes = useStyles();

  const onPhysicianChange = useCallback(value => onChange({ physician: value }), [onChange]);
  const onDateSelect = useCallback(d => onChange({ date: format(d, 'YYYY-MM-DD') }), [onChange]);
  const label = useMemo(() => format(date, buttonFormat || 'MMMM D, YYYY'), [date, buttonFormat]);

  return (
    <div className={classes.root}>
      {!withoutPhysician && (
        <Box minWidth={150}>
          <PhysicianDropdown onChange={onPhysicianChange} value={physician} menuWidthFollowContent />
        </Box>
      )}
      <Dropdown contentComponent={CalendarContent} contentProps={{ date, onSelect: onDateSelect }}>
        <Button variant="contained">{label}</Button>
      </Dropdown>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

export default Filters;
